/* globals jQuery, grecaptcha, APPLICATION_PORTAL */

import determineTarget from './theme/determine-target';
import toggleElement from './theme/toggle-element';

jQuery( $ => {
	// =========================
	// ! Form Swap Toggles
	// =========================

	$( '.js-form-toggle' ).click( function() {
		const target = determineTarget( this );
		const parent = this.closest( '.reach-form-wrapper' );
		if ( target ) {
			parent.setAttribute( 'aria-hidden', true );
			toggleElement( target, true, true );
		}
	} );

	// =========================
	// ! Range Controls
	// =========================

	$( '.reach-score-control' ).each( function() {
		const $input = $( this ).find( 'input[type="range"]' );
		const $value = $( this ).find( '.reach-score-control__value' );

		$input.on( 'input', function() {
			$value.text( ( $input.val() * 100 ) + '%' );
		} );
		$value.text( ( $input.val() * 100 ) + '%' );
	} );

	// =========================
	// ! Form Handling
	// =========================

	let withRecaptcha = function( callback ) {
		callback();
	};

	if ( typeof grecaptcha !== 'undefined' && typeof APPLICATION_PORTAL?.recaptcha !== 'undefined' ) {
		grecaptcha.ready( () => {
			withRecaptcha = function( callback ) {
				grecaptcha.execute( APPLICATION_PORTAL.recaptcha, { action: 'homepage' } )
					.then( callback );
			};
		} );
	}

	function submitWithRecaptcha( event ) {
		event.preventDefault();
		this.removeEventListener( 'submit', submitWithRecaptcha );
		withRecaptcha( token => {
			if ( token ) {
				const input = document.createElement( 'input' );
				input.name = 'grecaptcha';
				input.type = 'hidden';
				input.value = token;

				this.appendChild( input );
			}

			this.submit();
			this.addEventListener( 'submit', submitWithRecaptcha );
		} );
	}

	$( '.reach-form' ).each( function() {
		this.addEventListener( 'submit', submitWithRecaptcha );
	} );
} );
